import {
  faArrowTrendUp,
  faArrowsUpDownLeftRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IKImage } from "imagekitio-react";
import Slider from "react-slick";
import "../pricingslider.css";

const HeroSection = ({ isCareerGoal, cardDatas, reviews }) => {
  const [heroPlan, setHeroPlan] = useState(1);
  const [heroTitle, setHeroTitle] = useState("");
  const user_role = useSelector((store) => store?.userSubscription?.user_role);
  const imageRoutes = [
    "https://img.learntube.ai/public-assets/Optimized_folder/PhonePe.svg?updatedAt=1688366006884",
    "https://img.learntube.ai/public-assets/Optimized_folder/Byjus.svg?updatedAt=1688366004425",
    "https://img.learntube.ai/public-assets/Optimized_folder/Flipkart.svg?updatedAt=1688366003066",
    "https://img.learntube.ai/public-assets/Optimized_folder/Myntra.svg?updatedAt=1688366005500",
    "https://img.learntube.ai/public-assets/Optimized_folder/Ola.svg?updatedAt=1688366006998",
  ];

  const settings = {
    dots: false,
    slidesToShow: 3,
    rows: 1,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    easing: "linear",
    cssEase: "linear",
    infinite: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          slidesToShow: 1,
          rows: 1,
          speed: 300,
          cssEase: "linear",
        },
      },
    ],
  };
  const userDesignation = {
    201737: "CRM Executive",
    33015: "Application Developer",
    196419: "Freelance UI/UX Designer",
    195206: "Business Development Manager",
    479672: "Senior UI/UX Developer",
  };
  useEffect(() => {
    if (isCareerGoal?.is_show) {
      if (isCareerGoal?.selected_goal?.product === "LearnTube Pro") {
        setHeroPlan(1);
        setHeroTitle("With LearnTube Pro You Get");
      }
      if (isCareerGoal?.selected_goal?.product === "LearnTubeX") {
        setHeroPlan(2);
        setHeroTitle("With LearnTubeX You Get");
      }
      if (isCareerGoal?.selected_goal?.product === "LearnTube Max") {
        setHeroPlan(3);
        setHeroTitle("LearnTube Max Will Transform Your Life");
      }
    } else {
      if (user_role === 1) {
        setHeroPlan(1);
        setHeroTitle("Upgrade To LearnTube Pro And Build An Amazing Profile!");
      } else if (user_role === 2) {
        setHeroPlan(2);
        setHeroTitle("With LearnTubeX You Get");
      } else if (user_role === 4) {
        setHeroPlan(3);
        setHeroTitle("Upgrade To LearnTube Max And Get Hired Quick!");
      } else if (user_role === 6) {
        setHeroPlan(3);
        setHeroTitle("How LearnTube Max Is Transforming Your Life!");
      }
    }
  }, [isCareerGoal, cardDatas]);
  // console.log(imageRoutes)

  return (
    <div className="flex w-full flex-col items-center justify-center md:mt-10 md:w-7/12">
      <h1 className="w-full  bg-[#C2F0FF] py-2 px-4 text-center text-[20px] font-semibold leading-tight text-[#086788]  md:text-[32px]">
        {heroTitle}
      </h1>
      {heroPlan === 1 ? (
        <div className="item-center text-md mt-10 flex w-11/12 grid-cols-2 flex-col justify-center rounded-lg border-2 bg-white px-2 py-2 md:grid md:w-full md:gap-x-3 md:text-[24px]">
          <div className="rounded-lg border-2 px-4 py-2 text-center ">
            <FontAwesomeIcon
              icon={faArrowTrendUp}
              className="mr-2 text-[#2BBD13]"
            />
            <span className="mr-1 font-bold text-[#2BBD13]">71%</span>chance of
            getting selected for Interviews
          </div>
          <div className="mt-2 rounded-lg border-2 px-4 py-2 text-center md:mt-0">
            <FontAwesomeIcon
              icon={faArrowTrendUp}
              className="mr-2 text-[#2BBD13]"
            />
            <span className="mr-1 font-bold text-[#2BBD13]">10%</span>higher pay
            than the average <span className="font-bold">starting salary</span>
          </div>
        </div>
      ) : heroPlan === 2 ? (
        <div className="item-center text-md mt-10 flex w-11/12 grid-cols-2 flex-col justify-center rounded-lg border-2 bg-white px-2 py-2 md:w-full md:gap-x-3 md:text-[24px] ">
          <div className="rounded-lg border-2 px-4 py-2 text-center">
            <FontAwesomeIcon
              icon={faArrowTrendUp}
              className="mr-2 text-[#2BBD13]"
            />
            <span className="mr-1 font-bold text-[#2BBD13]">73%</span>chance of
            getting hired by:
            <div className="item-center flex w-full flex-row justify-center">
              {imageRoutes.map((item) => (
                <img
                  src={item}
                  className="ml-1 mr-1 h-6"
                  height={24}
                  alt="images"
                ></img>
              ))}
            </div>
          </div>

          <div className="mt-2 rounded-lg border-2 px-4 py-2 text-center md:mt-0">
            <FontAwesomeIcon
              icon={faArrowTrendUp}
              className="mr-2 text-[#2BBD13]"
            />
            <span className="mr-1 font-bold text-[#2BBD13]">27%</span>higher pay
            than the average <span className="font-bold">starting salary</span>
          </div>
          <div className="mt-2 rounded-lg border-2 px-4 py-2 text-center md:mt-0">
            Average salary hike of
            <span className="ml-1 font-bold text-[#2BBD13]">41%</span>
          </div>
        </div>
      ) : (
        <div className="item-center text-md mt-10 flex w-11/12 grid-cols-2 flex-col justify-center rounded-lg border-2 bg-white px-2 py-2 md:grid md:w-full md:gap-x-3 md:text-[24px] ">
          <div className="rounded-lg border-2 px-4 py-2 text-center">
            <FontAwesomeIcon
              icon={faArrowTrendUp}
              className="mr-2 text-[#2BBD13]"
            />
            <span className="mr-1 font-bold text-[#2BBD13]">74%</span>chance of
            getting hired by:
            <div className="flex w-full flex-row items-center justify-center">
              <img
                src="https://img.learntube.ai/public-assets/Optimized_folder/Companys.svg?updatedAt=1688366003209"
                alt="company images"
                height={24}
                className=""
              ></img>
            </div>
          </div>
          <div className="mt-2 rounded-lg border-2 px-4 py-2 text-center md:mt-0">
            <FontAwesomeIcon
              icon={faArrowTrendUp}
              className="mr-2 text-[#2BBD13]"
            />
            <span className="mr-1 font-bold text-[#2BBD13]">88%</span>chance of
            getting hired by:
            <div className="item-center flex w-full flex-row justify-center">
              {imageRoutes.map((item) => (
                <img
                  src={item}
                  className="ml-1 mr-1 h-6"
                  height={24}
                  alt="images"
                ></img>
              ))}
            </div>
          </div>

          <div className="mt-2 rounded-lg border-2 px-4 py-2 text-center">
            <span className="mr-1 font-bold text-[#2BBD13]">43%</span>higher pay
            than the average <span className="font-bold">starting salary</span>
          </div>
          <div className="mt-2 rounded-lg border-2 px-4 py-2 text-center">
            Average salary hike of
            <span className="ml-1 font-bold text-[#2BBD13]">56%</span>
          </div>
        </div>
      )}
      <div className=" pricing-scroll mt-4 w-9/12 rounded-xl text-black shadow-xl md:w-11/12 md:shadow-none">
        <Slider {...settings}>
          {reviews?.length > 0 &&
            reviews?.map((item, index) => (
              <div className="   flex flex-col items-center justify-center    px-2 font-light md:py-2  ">
                <div className="flex h-[200px] flex-col items-center justify-center rounded-lg bg-[#E8F9FF] px-2 py-2 shadow-lg ">
                  <div className="self-center text-center text-sm italic text-pricing_blue">
                    {item?.feedback}
                  </div>
                  <div className="mt-2 flex flex-row items-center justify-center">
                    <img
                      src={item?.profile_image}
                      className="mr-1 h-10 w-10 rounded-full"
                      width={40}
                      height={40}
                      alt="profile image"
                    ></img>
                    <div className="text-start ml-2 flex flex-col items-start justify-center">
                      <div className="md:text-md text-[12px] ">
                        {item?.name}
                      </div>
                      <div className=" text-[10px] text-[#666666] md:text-xs ">
                        {userDesignation[item?.user_id]}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </Slider>
      </div>
    </div>
  );
};

export default HeroSection;
